import { useState, useEffect, useMemo } from 'react';

export const useRecommendations = (
    initialRecommendations: string[],
    onSave: (recommendations: string[]) => void,
) => {
    const [localRecs, setLocalRecs] = useState<string[]>(initialRecommendations);
    const [newRec, setNewRec] = useState('');

    useEffect(() => {
        setLocalRecs(initialRecommendations);
    }, [initialRecommendations]);

    const handleAdd = () => {
        if (newRec.trim()) {
            setLocalRecs(prev => [...prev, newRec.trim()]);
            setNewRec('');
        }
    };

    const handleDelete = (indexToDelete: number) => {
        setLocalRecs(prev => prev.filter((_, index) => index !== indexToDelete));
    };

    const handleSave = () => {
        onSave(localRecs);
    };

    const hasUnsavedChanges = useMemo(() => {
        return JSON.stringify(localRecs) !== JSON.stringify(initialRecommendations);
    }, [localRecs, initialRecommendations]);

    return {
        localRecs,
        newRec,
        setNewRec,
        hasUnsavedChanges,
        handleAdd,
        handleDelete,
        handleSave,
    };
};
